var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandValue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.325 3.675C50.925 2.45 49.175 1.75 47.25 1.75H32.2C30.1 1.75 28 2.625 26.425 4.2L4.2 26.425C2.8 28 1.925 29.925 1.75 31.85C1.575 33.95 2.275 35.875 3.675 37.275L18.725 52.325C19.95 53.55 21.7 54.25 23.625 54.25C25.725 54.25 27.825 53.375 29.4 51.8L51.625 29.575C53.2 28 54.075 25.9 54.075 23.8L54.25 8.75C54.25 6.825 53.55 5.075 52.325 3.675ZM50.75 23.8C50.75 25.025 50.225 26.25 49.35 27.125L27.125 49.35C26.25 50.225 25.025 50.75 23.8 50.75C22.75 50.75 21.875 50.4 21.35 49.7L6.3 34.65C5.6 34.125 5.25 33.075 5.25 32.025C5.25 30.8 5.775 29.75 6.65 28.875L28.875 6.825C29.75 5.775 30.975 5.25 32.2 5.25H47.25C48.3 5.25 49.175 5.6 49.7 6.3C50.4 6.825 50.75 7.7 50.75 8.75V23.8Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.925 10.8499C34.65 13.1249 34.65 16.7999 36.925 19.0749C37.975 20.1249 39.55 20.8249 40.95 20.8249C42.35 20.8249 43.925 20.2999 44.975 19.0749C47.25 16.7999 47.25 13.1249 44.975 10.8499C43.05 8.7499 39.2 8.7499 36.925 10.8499ZM42.7 16.6249C41.825 17.4999 40.25 17.4999 39.55 16.6249C38.5 15.7499 38.5 14.1749 39.375 13.2999C39.725 12.9499 40.425 12.5999 40.95 12.5999C41.475 12.5999 42.175 12.7749 42.525 13.2999C43.575 14.1749 43.575 15.7499 42.7 16.6249Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandValue);
export default __webpack_public_path__ + "static/media/brand-value.1567fd93f92d423d3ccf664ffca9e849.svg";
export { ForwardRef as ReactComponent };